// extracted by mini-css-extract-plugin
export default {"infoTooltip":"info-tooltip_infoTooltip__ZowcC","infoTooltipIcon":"info-tooltip_infoTooltipIcon__7CZ6h"};